import { Stack, Typography, useTheme } from "@mui/material";
import { UserX } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const FaultyFinancialBalance = () => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			gap={1.6}
			bgcolor={theme.palette.grey[100]}
			p={1.6}
			borderRadius={"12px"}
		>
			<Typography fontWeight={600} fontSize={16}>
				{t(Resources.Dashboard.FinancialBalance.title)}
			</Typography>
			<Stack alignItems="center" textAlign="center" gap={1}>
				<UserX size={40} />
				<Typography variant="body1" color={theme.palette.grey[500]}>
					{t(Resources.Dashboard.FinancialBalance.clientNotFound)}
				</Typography>
			</Stack>
		</Stack>
	);
};
